import { makeEnvironmentProviders } from '@angular/core';
import { AppInsightsConfig, provideAppInsights } from '@mri-platform/angular-app-insights';
import { AgBarCloudRoleTelemetryInitializerProvider } from './ag-bar-cloud-role-telemetry-initializer';
import { AppInsightsErrorAppenderProvider } from './app-insights-appender.provider';
import { AppInsightsConfigProvider } from './app-insights-config.provider';

export function provideAppInsightsIntegration<T extends object = object>(config?: AppInsightsConfig<T>) {
  return makeEnvironmentProviders([
    provideAppInsights(config),
    AppInsightsErrorAppenderProvider,
    AppInsightsConfigProvider,
    AgBarCloudRoleTelemetryInitializerProvider
  ]);
}
